import { AuthService } from '@card-software/nexus-utilities';
import { Asset } from '@app/models/asset/asset';

export class WeightStationAccessUtil {
  /**
   * A station with no accessible roles is open to every station user; otherwise the
   * user needs at least one of the roles configured on the asset in Asset.UI.
   */
  public static canAccess(station: Asset | null | undefined): boolean {
    const accessibleRoles = station?.weightStationDetails?.accessibleRoles ?? [];
    return accessibleRoles.length === 0 || AuthService.hasAnyRole(accessibleRoles);
  }
}
